import axios from 'axios';
import { JsonResponse } from 'core/models/response';
import { BoardMember, BoardMemberListResponse } from '../models/members';

export const onGetMembersList = async (boardId: string, page: number = 1) => {
	try {
		const response = await axios.get<JsonResponse<BoardMemberListResponse>>(`dashboard/boards/${boardId}/members`, {
			params: { page },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetMemberById = async (boardId: string, memberId: string) => {
	try {
		const response = await axios.get<JsonResponse<BoardMember>>(`dashboard/boards/${boardId}/members/${memberId}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetMemberByNationalId = async (nationalId: string) => {
	try {
		const response = await axios.get<JsonResponse<BoardMember & { can_edit: boolean }>>(
			`dashboard/members/find-by-national-id?national_id=${nationalId}`,
		);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onAddMemberToBoard = async (boardId: string, payload: FormData) => {
	try {
		const response = await axios.post<JsonResponse<BoardMember>>(`dashboard/boards/${boardId}/members`, payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onEditMemberFromBoard = async (boardId: string, memberId: number, payload: FormData) => {
	try {
		const response = await axios.post<JsonResponse<BoardMember>>(`dashboard/boards/${boardId}/members/${memberId}`, payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onDeleteMemberFromBoard = async (boardId: number, memberId: number) => {
	try {
		const response = await axios.delete<JsonResponse<BoardMember>>(`dashboard/boards/${boardId}/members/${memberId}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onUpdateBoardSecretary = async (boardId: number, payload: FormData) => {
	try {
		const response = await axios.post<JsonResponse<BoardMember>>(`dashboard/boards/${boardId}/replace-secretary`, payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
